// src/connection/aiFrames.ts — one agent-service transcript frame → one AI-panel event. The live
// stream and a batched History Page (session.replay, agent-chat-speed Decision 2) carry the same
// frame objects (omega-ai-agent-service src/replay.ts formatReplayEvents, src/eventTranslate.ts
// translate), so both go through this one mapping.
import { AiEvent, AiEventType } from "../types/ai-event";

export function frameToAiEvent(data: any): AiEvent | null {
  const timestamp: number = data?.timestamp || Date.now();
  switch (data?.type) {
    case "agent.message":
      return data.role === "user"
        ? { type: AiEventType.USER_MESSAGE, id: data.id, content: data.content, timestamp }
        : { type: AiEventType.AGENT_MESSAGE, id: data.id, content: data.content, timestamp };
    case "agent.tool_use":
      // A replayed tool part can lack state.input (replay.ts: input: part.state?.input) and
      // ToolCallCard reads fields of input, so it is never undefined here.
      return { type: AiEventType.TOOL_USE, id: data.id, name: data.name, input: data.input ?? {}, timestamp };
    case "agent.tool_result":
      return { type: AiEventType.TOOL_RESULT, toolUseId: data.toolUseId, output: data.output, timestamp };
    case "session.background_tasks":
      return {
        type: AiEventType.BACKGROUND_TASKS,
        tasks: Array.isArray(data.tasks) ? data.tasks.map((t: any) => ({ id: String(t?.id ?? ""), description: String(t?.description ?? "") })) : [],
        timestamp,
      };
    default:
      return null;
  }
}
